import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.hero--slider .hero__items');

$slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    arrows: true,
    dots: true,
    draggable: false,
    prevArrow: '<i class="slick-prev hero__slide-prev hero__slide-arrow"></i>',
    nextArrow: '<i class="slick-next hero__slide-next hero__slide-arrow"></i>',
    appendArrows: $('.hero__slide-arrows'),
    appendDots: $('.hero__slide-dots'),
    responsive: [{
        breakpoint: 992,
        settings: {
            draggable: true
        }
    }]
});

$('.big-tiles--slider .big-tiles__items').each(function () {
    $(this).slick({
        infinite: true,
        arrows: true,
        dots: true,
        draggable: true,
        prevArrow: '<i class="slick-prev big-tiles__slide-prev big-tiles__slide-arrow"></i>',
        nextArrow: '<i class="slick-next big-tiles__slide-next big-tiles__slide-arrow"></i>',
        appendArrows: $(this).closest('.big-tiles--slider').find('.big-tiles__arrows'),
        appendDots: $(this).closest('.big-tiles--slider').find('.big-tiles__dots'),
        slidesToShow: 1,

        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            }
        }]
    });
})



$('.region__big-images').each(function () {
    $(this).slick({
        infinite: false,
        arrows: true,
        dots: true,
        draggable: false,
        asNavFor: $(this).closest('.region__images').find('.region__small-images'),
        prevArrow: '<i class="slick-prev region__slide-prev region__slide-arrow"></i>',
        nextArrow: '<i class="slick-next region__slide-next region__slide-arrow"></i>',
        appendArrows: $(this).closest('.region__images').find('.region__arrows'),
        appendDots: $(this).closest('.region__images').find('.region__dots'),
        slidesToShow: 1,
        fade: true,
        waitForAnimate: false,


        responsive: [{
            breakpoint: 992,
            settings: {
                draggable: true,
                fade: false,
                waitForAnimate: true,
            }
        }]
    });
})



$('.region__small-images').each(function () {
    var $regionSlider = $(this);
    $regionSlider.slick({
        infinite: false,
        arrows: false,
        dots: false,
        draggable: true,
        asNavFor: $(this).closest('.region__images').find('.region__big-images'),
        slidesToShow: 5,
        waitForAnimate: false,
        variableWidth: true,
    });

    $(this).on('click', '.slick-slide', function () {
        var newSlide = $(this).data('slick-index');
        $regionSlider.slick('slickGoTo', newSlide);
    })
})




$('.related-news__items').each(function () {
    $(this).slick({
        infinite: true,
        arrows: true,
        dots: true,
        draggable: true,
        prevArrow: '<i class="slick-prev related-news__slide-prev related-news__slide-arrow"></i>',
        nextArrow: '<i class="slick-next related-news__slide-next related-news__slide-arrow"></i>',
        appendArrows: $(this).closest('.related-news').find('.related-news__arrows'),
        appendDots: $(this).closest('.related-news').find('.related-news__dots'),
        slidesToShow: 2,

        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            }
        }]
    });
})
